import { render, staticRenderFns } from "./FormControlMBasketMerchantdetailsSettings.vue?vue&type=template&id=61324f25&scoped=true"
import script from "./FormControlMBasketMerchantdetailsSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./FormControlMBasketMerchantdetailsSettings.vue?vue&type=script&setup=true&lang=js"
import style0 from "./FormControlMBasketMerchantdetailsSettings.vue?vue&type=style&index=0&id=61324f25&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61324f25",
  null
  
)

export default component.exports